import { render } from "./manage-user.vue?vue&type=template&id=05d251b4&scoped=true"
import script from "./manage-user.vue?vue&type=script&lang=js"
export * from "./manage-user.vue?vue&type=script&lang=js"

import "./manage-user.vue?vue&type=style&index=0&id=05d251b4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d251b4"]])

export default __exports__